<div *ngIf="isAuthenticated$ | async; else errorTemplate" class="app-root">
  <div class="app-root__wrapper">
    <cp-header></cp-header>
    <cp-main></cp-main>
    <cp-bottom-navigation></cp-bottom-navigation>
  </div>
</div>

<ng-template #errorTemplate>
  <cp-error *ngIf="auth0Error$ | async; else loader"></cp-error>
</ng-template>

<ng-template #loader>
  <ui-progress-spinner spinnerText="Loading..."></ui-progress-spinner>
</ng-template>
